import React from "react";
import { Component } from "preact";
import { scrollToErrors } from "../../../utils/ScrollToError";

import { Field, reduxForm } from "redux-form";
import { required, email } from "../../../utils/Validators";
import InputField from "../../../components/Inputs/InputField";
import TextAreaField from "../../../components/Inputs/TextAreaField";
import SubmitButton from "../../../components/Inputs/SubmitButton";

import styles from "./GeneralForm.scss";

import EmailService from "../../../services/EmailService";

const loadingIcon = require("../../../assets/loading/ic_loading_ticket.svg");
const tickIcon = require("../../../assets/loading/ic_green_tick.svg");

let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class GeneralSupport extends Component {
  handleInputChange(event) {
    const target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name === "textArea") {
      this.setState({
        textArea: value
      });
      value = value.replace(/(\r\n|\n|\r)/gm, "<br />");
      this.setState({
        response: value
      });
    } else {
      this.setState({
        [name]: value
      });
    }
  }

  handleSubmitForm(values) {
    const { locale } = this.props;
    let { email, firstName, lastName, textArea } = values;
    if (
      re.test(String(email).toLowerCase()) &&
      firstName !== "" &&
      lastName !== "" &&
      textArea !== ""
    ) {
      EmailService.post(email, null, 0, this.constructEmail(values), locale)
        .then(response => {
          this.setState({
            isLoading: false,
            sent: true
          });
        })
        .catch(err => {});
    }
  }

  constructEmail(values) {
    let { firstName, lastName, textArea, mobile } = values;
    const response = textArea.replace(/(\r\n|\n|\r)/gm, "<br />");
    return { firstName, lastName, response, mobile };
  }

  reset() {
    this.setState({
      email: null,
      firstName: null,
      lastName: null,
      textArea: null,
      response: null,
      isLoading: false,
      sent: false
    });
  }

  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.constructEmail = this.constructEmail.bind(this);
    this.reset = this.reset.bind(this);
    this.state = {
      email: null,
      firstName: null,
      lastName: null,
      textArea: null,
      response: null,
      isLoading: false,
      sent: false
    };
  }

  render() {
    const { isLoading, sent } = this.state;
    const { handleSubmit, reset } = this.props;
    if (sent || isLoading) {
      return (
        <div className={styles.content}>
          <div className={styles.sentWrapper}>
            {!isLoading ? (
              <div>
                <img
                  src={loadingIcon}
                  className={styles.loadingShrink}
                  alt="Loading Icon"
                />
                <img
                  src={tickIcon}
                  className={styles.tick}
                  alt="Tick Icon"
                  name="Sent Tick"
                />
              </div>
            ) : (
              <div>
                <img
                  src={loadingIcon}
                  className={styles.loading}
                  alt="Loading Icon"
                />
              </div>
            )}
            <h2>Your message has been sent!</h2>
            <p>Our support team will be in touch shortly.</p>
            <button
              className={styles.button}
              onClick={() => {
                this.reset();
                reset();
              }}
              aria-label="Send a New Message"
            >
              Send a New Message
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.content}>
        <form
          onSubmit={handleSubmit(values => {
            this.handleSubmitForm(values);
          })}
        >
          <Field
            name="email"
            component={InputField}
            placeholder="Email"
            label="Email*"
            validate={[required, email]}
            autocomplete="email"
          />
          <Field
            name="firstName"
            component={InputField}
            placeholder="First Name"
            label="First Name*"
            validate={required}
            autocomplete="given-name"
          />
          <Field
            name="lastName"
            component={InputField}
            placeholder="Last Name"
            label="Last Name*"
            validate={required}
            autocomplete="family-name"
          />
          <Field
            name="mobile"
            component={InputField}
            placeholder="Mobile"
            label="Mobile"
          />
          <Field
            name="textArea"
            component={TextAreaField}
            placeholder="How can we help?"
            label="How can we help?*"
            validate={required}
          />
          <SubmitButton />
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: "generalForm", // a unique identifier for this form
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(GeneralSupport);
